import { useState } from 'react'
import { Box, TextField, IconButton } from '@/CommonComponents'

export default function MarkdownEditor({
  content,
  onChange,
}: {
  content: string
  onChange: (newContent: string) => void
}) {
  const [editContent, setEditContent] = useState(content)

  const handleSave = () => {
    onChange(editContent)
  }

  const handleCancel = () => {
    onChange(content)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <TextField
        multiline
        rows={8}
        value={editContent}
        onChange={(e) => {
          setEditContent(e.target.value)
        }}
        variant="outlined"
        size="small"
      />
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
        <IconButton onClick={handleCancel} icon="close" size="small" color="error" />
        <IconButton onClick={handleSave} icon="check" size="small" color="success" />
      </Box>
    </Box>
  )
}
